<template>
  <v-alert
    :value="true"
    color="warning"
    icon="info"
    v-if="purchaseStatusId == purchaseStatus.PURCHASE_NOT_VERIFIED"
    outline
  >{{ $t('message.verify') }}</v-alert>

  <v-alert
    :value="true"
    color="primary"
    icon="info"
    v-else-if="purchaseStatusId == purchaseStatus.PURCHASE_VERIFIED"
    outline
  >{{ $t('message.verified') }}</v-alert>

  <v-alert
    :value="true"
    color="yellow"
    icon="info"
    v-else-if="purchaseStatusId == purchaseStatus.PURCHASE_SHIPPED"
    outline
  >{{ $t('message.shipped') }}</v-alert>

  <v-alert
    :value="true"
    color="light-green accent-4"
    icon="check"
    v-else-if="purchaseStatusId == purchaseStatus.PURCHASE_DELIVERED"
    outline
  >{{ $t('message.delivered') }}</v-alert>

  <v-alert
    :value="true"
    color="amber"
    icon="info"
    v-else-if="purchaseStatusId == purchaseStatus.PURCHASE_REJECTED"
    outline
  >{{ $t('message.paymentRejected') }}</v-alert>

  <v-alert :value="true" color="error" icon="info" v-else outline>{{ $t('message.cancelled') }}</v-alert>
</template>

<script>
import { purchaseStatus } from "../../constants/constants";

export default {
  name: "purchaseStatus",
  props: {
    purchaseStatusId: {
      required: true,
      type: Number
    }
  },
  data() {
    return {
        purchaseStatus: purchaseStatus
    };
  },
  methods: {}
};
</script>

<style>
</style>